// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"castle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6 5H18C18 10.3333 18 15.6667 18 21H6V5Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M14 14H10V21H14V14Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M2 21H6V15H2V21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M18 21H22V15H18V21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M14 14H10V21H14V14Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2 15V21H6V15H2ZM2 15V14M22 15V21H18V15H22ZM22 15V14M10 14H14V21H10V14Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M18 5V3M18 5H14M18 5C18 10.3333 18 15.6667 18 21H6V5M6 5V3M6 5H10M10 3V5M10 5H14M14 3V5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CastleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'castle',
    ref,
    icon: element,
  },
));

CastleIcon.displayName = 'CastleIcon';

export default CastleIcon;
